import { ReportTypeEnum } from "../constants/constants";
import { AMOUNT_UTIL } from "./amount.utils";

const Number_Colunms = [
    "Exposure at Default ($)",
    "Economic Capital ($)",
    "Concentration Charge ($)",
    "Outstanding",
    "Undrawn_Amount",
    "Risk Adjusted Exposure (Not Equivalent to Accounting Exposure)",
    "Portfolio Yield",
    "Risk Cost",
    "Treasury Cost",
    "Capital Cost",
    "Risk-adjusted Return",
    "Economic Value ($)",
    "Book Value ($)",
    "Modified Duration",
    "Cost of servicing",
    "No.of Transactions Below Hurdle Rate"
]

const PercentColumns = [
    "Average RAROC"
]


const FrontierPercentColumns = [
    "Forward-looking base case default rate",
    "Forward-looking stress case default rate Stress",
    "Forward-looking reverse case default Rate",
    "Downturn LGD",
    "Stressed LGD"
]

const FrontierAmountColumns = [
    "Base case Credit risk required capital",
    "Stress case exposure",
    "Base case exposure",
    "Reverse case exposure",
    "Reverse case Credit risk required capital",
    "Stress case concentration risk required capital",
    "Stress case Credit risk required capital"
]

const mergeRow = (name: string, value: any, index: number, data: any[]) => {
    const obj = {
        children: <div>{value}</div>,
        props: { rowSpan: 1 },
    };


    if (data[index - 1] && data[index][name] === data[index - 1][name]) {
        obj.props.rowSpan = 0;
    } else {
        let rowSpan = 1
        for (let i = index; i < data.length; i++) {

            if (data[i + 1] && data[i][name] === data[i + 1][name]) {
                rowSpan++;
            } else {
                break;
            }
        }
        obj.props.rowSpan = rowSpan;
    }

    return obj;
}

const mergeRowNullValue = (name: string, value: any, index: number, data: any[]) => {
    const obj = {
        children: <div>{value}</div>,
        props: { rowSpan: 1 },
    };

    if (data[index][name] === null) {
        obj.props.rowSpan = 0;
    } else {
        let rowSpan = 1
        for (let i = index + 1; i < data.length; i++) {

            if (data[i][name] === null) {
                rowSpan++;
            } else {
                break;
            }
        }
        obj.props.rowSpan = rowSpan;
    }

    return obj;
}

const getColumnsTableData = (data?: any[], riskType?: ReportTypeEnum, cl?: any[], type_code: string = "") => {
    if (!data || !data.length) {
        return []
    }

    const inputKeys = cl ? cl : Object.keys(data[0]);
    const columns = inputKeys.map(key => {

        // set align
        let align = "left";
        if ((riskType === ReportTypeEnum.MarketRisk && key === "Values") ||
            (riskType === ReportTypeEnum.BusinessRisk && key === "Values") ||
            (riskType === ReportTypeEnum.InterestRateRisk && key === "Value") ||
            Number_Colunms.includes(key) ||
            PercentColumns.includes(key) ||
            FrontierPercentColumns.some(x => key.includes(x)) ||
            FrontierAmountColumns.some(x => key.includes(x))
        ) {
            align = "right"
        }

        return {
            title: key,
            dataIndex: key,
            key: key,
            align: align,
            render: (value: any, row: any, index: number) => {
                let obj = {
                    children: <div>{value}</div>,
                    props: { rowSpan: 1 },
                };



                // merge rows
                if (riskType === ReportTypeEnum.CreditRisk ||
                    riskType === ReportTypeEnum.ConcentrationRisk ||
                    riskType === ReportTypeEnum.CreditandConcentrationStressTesting) {
                    const columnNeedMergeRow = "Portfolio";

                    if (key === columnNeedMergeRow) {
                        if (riskType === ReportTypeEnum.CreditandConcentrationStressTesting) {
                            obj = mergeRow(columnNeedMergeRow, value, index, data);
                        } else {
                            obj = mergeRowNullValue(columnNeedMergeRow, value, index, data);
                        }
                    }
                }

                // format values
                if (riskType === ReportTypeEnum.MarketRisk && key === "Values") {
                    if (row.Parameters === "Annualized Mean return" ||
                        row.Parameters === "Annualized Standard deviation" ||
                        row.Parameters === "Confidence level" ||
                        row.Parameters === "Confidence level" ||
                        row.Parameters === "VaR %") {
                        obj.children = <div>{AMOUNT_UTIL.converNumberToPercentage(value)}</div>;
                    } else if (row.Parameters === "Z value" ||
                        row.Parameters === "Portfolio Size") {
                        obj.children = <div>{AMOUNT_UTIL.convertNumericToFormattedAmount(value)}</div>;
                    } else if (row.Parameters === "VaR") {
                        obj.children = <div>{AMOUNT_UTIL.convertNumericToFormattedAmount(value)}</div>;
                    }
                } else if (riskType === ReportTypeEnum.BusinessRisk && key === "Value") {
                    if (row.Name === "Business risk capital") {
                        obj.children = <div>{AMOUNT_UTIL.convertNumericToFormattedAmount(value)}</div>;
                    }
                } else if (riskType === ReportTypeEnum.InterestRateRisk &&
                    type_code === "IRR_RESULT2") {
                    if (key === "Value") {
                        if (row.Name === "Coverage Level") {
                            obj.children = <div>{value * 100}</div>;
                        } else {
                            obj.children = <div>{AMOUNT_UTIL.converNumberToPercentage(value)}</div>;
                        }
                    }

                } else if (riskType === ReportTypeEnum.InterestRateRisk &&
                    type_code === "IRR_RESULT3") {
                    if (key === "Name") {
                        if (value === "Regulatory CAPITAL required (CAD)") {
                            obj.children = <div className="primary-div">{value}</div>;
                        }
                    } else if (key === "Value") {


                        if (row.Name === "Coverage Level") {
                            obj.children = <div>{value * 100}</div>;
                        }
                        // else if (row.Name === "Equity" || row.Name === "Regulatory CAPITAL required (CAD)") {
                        //     obj.children = <div>{`(${AMOUNT_UTIL.convertNumericToFormattedString(value)})`}</div>;
                        // } 
                        else {
                            obj.children = <div>
                                {AMOUNT_UTIL.convertNumericToFormattedString(value)}
                            </div>
                        }

                    }

                }
                else if (Number_Colunms.includes(key)) {
                    obj.children = <div>
                        {AMOUNT_UTIL.convertNumericToFormattedString(value)}
                    </div>
                } else if (PercentColumns.includes(key) || FrontierPercentColumns.some(x => key.includes(x))) {
                    obj.children = <div>
                        {AMOUNT_UTIL.converNumberToPercentage(value * 100)}
                    </div>
                } else if (FrontierAmountColumns.some(x => key.includes(x))) {
                    obj.children = <div>
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(value)}
                    </div>
                }

                return obj
            }
        }

    });

    return columns
}

export const DATA_TABLE_UTIL = {
    getColumnsTableData
}